import { lazy } from 'react'

const AuthRoute = [
  {
    path: '/login',
    component: lazy(() => import('../../auth/Login')),
    layout: '',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/verify-otp',
    component: lazy(() => import('../../auth/VerifyOTP')),
    layout: '',
    meta: {
      authRoute: true
    }
  },
  {
    path: '/forgot-password',
    component: lazy(() => import('../../auth/ForgotPassword')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  // {
  //   path: '/reset-password',
  //   component: lazy(() => import('../../views/authentication/ResetPassword')),
  //   layout: 'BlankLayout',
  //   meta: {
  //     authRoute: true
  //   }
  // }
]

export default AuthRoute
